import React, { useEffect, useState } from 'react';
import { Avatar, Button, Chip, Grid, Paper, Stack, Typography, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { companyService } from '../services/companyService';

interface DashboardHeaderProps {
  title?: string;
  subtitleChips?: string[];
  showLogout?: boolean;
  showNav?: boolean;
  currentPage?: 'workers' | 'companies' | 'profile';
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ title, subtitleChips = [], showLogout = true, showNav = false, currentPage }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [logoUrl, setLogoUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    const init = async () => {
      if (user?.role === 'empresa') {
        const existing = (user as any)?.image_url as string | undefined;
        if (existing) {
          setLogoUrl(existing);
          return;
        }
        try {
          const me = await companyService.getMyCompany();
          if (me?.image_url) setLogoUrl(me.image_url);
        } catch {}
      }
    };
    init();
  }, [user]);

  return (
    <Paper elevation={0} sx={{ p: 2, mb: 3, borderRadius: 2, background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)', color: 'white' }}>
      <Grid container alignItems="center" spacing={2}>
        <Grid item>
          {user?.role === 'empresa' && (logoUrl) ? (
            <Avatar src={logoUrl} sx={{ width: 56, height: 56, bgcolor: 'white' }} />
          ) : (
            <Avatar sx={{ bgcolor: 'white', color: '#1976d2', width: 56, height: 56 }}>
              {(user?.name || 'U')[0]?.toUpperCase?.()}
            </Avatar>
          )}
        </Grid>
        <Grid item xs>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>{title || `Hola, ${user?.name}`}</Typography>
          <Stack direction="row" spacing={1} sx={{ mt: 0.5, flexWrap: 'wrap' }}>
            {subtitleChips.map((c, idx) => (
              <Chip key={idx} size="small" label={c} sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: 'white' }} />
            ))}
          </Stack>
        </Grid>
        <Grid item>
          <Stack direction="row" spacing={1} alignItems="center">
            {showNav && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 1 }}>
                <Button
                  color="inherit"
                  onClick={() => navigate('/workers')}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 500,
                    borderRadius: 2,
                    px: 2,
                    py: 0.75,
                    backgroundColor: currentPage === 'workers' ? 'rgba(255,255,255,0.15)' : 'transparent',
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
                  }}
                >
                  Trabajadores
                </Button>
                {(user?.role === 'super_admin') && (
                  <Button
                    color="inherit"
                    onClick={() => navigate('/companies')}
                    sx={{
                      textTransform: 'none',
                      fontWeight: 500,
                      borderRadius: 2,
                      px: 2,
                      py: 0.75,
                      backgroundColor: currentPage === 'companies' ? 'rgba(255,255,255,0.15)' : 'transparent',
                      '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
                    }}
                  >
                    Empresas
                  </Button>
                )}
              </Box>
            )}
            {showLogout && (
              <Button variant="outlined" color="inherit" onClick={() => { logout(); window.location.href = '/login'; }}>
                Cerrar sesión
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DashboardHeader;


